import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Redirect, Route } from "react-router-dom"
import { routes } from "../../../constantes/routes"
import { TOKEN_KEY } from "../../../constantes/localStorageKeys"
import { infoProfileContactHospitalPresentationActions } from "../../../actions/accessToPresentationByContact/infoProfileContactHospitalPresentationActions"
import { configApi } from "../../../api/configApi"


const ProtectedRoutePresentation = (
    {
        component: Component,
        ...rest
    }
) => {
    const id  = rest.computedMatch.params.id

    const infoProfileContactHospitalPresentation = useSelector(state => state.infoProfileContactHospitalPresentation)

    const dispatch = useDispatch()
    const getInfoContactHospitalPresentation = () => dispatch(infoProfileContactHospitalPresentationActions.getInfoProfileContactHospitalPresentation(id))

    const [toRoute, setToRoute] = useState('')

    useEffect(async () => {
        const authStatus = await configApi.getAuthStatus()
        setToRoute( goToProtectedPage(authStatus.data))
        getInfoContactHospitalPresentation()
    }, [])

    useEffect(() =>{
    }, [toRoute])

    const goToProtectedPage = (enableAuth) => {
        if(enableAuth) {
            return (
                <Route
                    {...rest}
                    render={props =>
                        infoProfileContactHospitalPresentation?.id_ContactoPresentacion
                        && localStorage.getItem(TOKEN_KEY) ? 
                        <Component {...props} /> 
                        : 
                        <Redirect to={{ pathname: routes.LANDING }} />
                    }
                />
            )
        } 
        return (
            <Route
                {...rest}
                render={props =>
                    <Component {...props} /> 
                }
            />
        )        
    }

    return (
        <>
            { toRoute }
        </>

    )
}

export default ProtectedRoutePresentation